import { useFollowingIdReference } from './useFollowingIdReference';
export function useIsFollowing(sonarObjectId) {
    var _a, _b;
    return (_b = (_a = useFollowingIdReference()) === null || _a === void 0 ? void 0 : _a[sonarObjectId]) !== null && _b !== void 0 ? _b : false;
}
